export default <const>[
  {
    id: 'ball',
    stage: 'baby',
    player_level: 1,
    encyclopedia_order: 101,
    name_jp: 'ぶるぶる科タマ属',
    name_en: 'ball',
    greetings_jp: '…\nん…？だれコロ？',
    greetings_en: '...\nWho are you...?',
    stomach_ini: 41,
    love_ini: 41,
    dirtiness_ini: 0,
    urine_ini: 0,
    tooth_acidity_ini: 0,
    stomach_sec: 18,
    love_sec: 24,
    dirtiness_sec: 30,
    urine_sec: 36,
    tooth_acidity_sec: 72,
    scared_coefficient: 2,
    next_weights: {
      crab: 500,
      hamster: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'crab',
    stage: 'kid',
    player_level: 1,
    encyclopedia_order: 201,
    name_jp: 'ぶるぶる科カニ属',
    name_en: 'crab',
    greetings_jp: 'ちょっとおっきくなったカニ！',
    greetings_en: 'I got a little bit bigger',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    next_weights: {
      dog: 500,
      seaotter: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'dog',
    stage: 'youth',
    player_level: 1,
    encyclopedia_order: 301,
    name_jp: 'ぶるぶる科イヌ属',
    name_en: 'dog',
    greetings_jp: 'これからもいっぱい\n遊んでほしいヌ！\nキャンキャン！',
    greetings_en: 'Keep playing with me\b!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    next_weights: {
      whale: 500,
      giraffe: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'starball',
    stage: 'baby',
    player_level: 1,
    encyclopedia_order: 102,
    name_jp: 'ぶるぶる科ホシタマ属',
    name_en: 'starball',
    greetings_jp: 'ひ…\nだれスタ？',
    greetings_en: '...\nWho are you...?',
    stomach_ini: 41,
    love_ini: 41,
    dirtiness_ini: 0,
    urine_ini: 0,
    tooth_acidity_ini: 0,
    stomach_sec: 18,
    love_sec: 24,
    dirtiness_sec: 30,
    urine_sec: 36,
    tooth_acidity_sec: 72,
    scared_coefficient: 2,
    next_weights: {
      turtle: 500,
      hamster: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },

  {
    id: 'hamster',
    stage: 'kid',
    player_level: 1,
    encyclopedia_order: 202,
    name_jp: 'ぶるぶる科ハム属',
    name_en: 'hamster',
    greetings_jp: 'おっきくなったハム！',
    greetings_en: 'I got bigger!',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    next_weights: {
      cat: 500,
      seaotter: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'turtle',
    stage: 'kid',
    player_level: 1,
    encyclopedia_order: 203,
    name_jp: 'ぶるぶる科カメ属',
    name_en: 'turtle',
    greetings_jp: '今後ともよろしくカメ',
    greetings_en: 'Thank you for your continued support',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    next_weights: {
      dog: 500,
      cat: 500,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'beetle',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 204,
    name_jp: 'ぶるぶる科カブ属',
    name_en: 'beetle',
    greetings_jp: 'もうだいぶおっきいカブ！',
    greetings_en: 'I got bigger!',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'mouse',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 205,
    name_jp: 'ぶるぶる科ネズ属',
    name_en: 'mouse',
    greetings_jp: 'おっきくなったチュウ！\nよろしくだチュウ！',
    greetings_en: 'I got bigger! Thank you!',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'chick',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 206,
    name_jp: 'ぶるぶる科ヒヨ属',
    name_en: 'chick',
    greetings_jp: 'もしかして…。\nお母さんピヨ…？',
    greetings_en: 'Are you... my mom...?',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'mushroom',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 207,
    name_jp: 'ぶるぶる科キン属',
    name_en: 'mushroom',
    greetings_jp: 'もっともっと大きくなるキン！',
    greetings_en: 'I will get bigger and bigger!',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'frog',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 208,
    name_jp: 'ぶるぶる科ケロ属',
    name_en: 'frog',
    greetings_jp: 'ちょっとだけおっきくなったケロ！',
    greetings_en: 'I got a little bit bigger!',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'jellyfish',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 209,
    name_jp: 'ぶるぶる科クラゲ属',
    name_en: 'jellyfish',
    greetings_jp: 'もうだいぶオトナだユラー？',
    greetings_en: "I'm almost an adult, right?",
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'squirrel',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 210,
    name_jp: 'ぶるぶる科リス属',
    name_en: 'squirrel',
    greetings_jp:
      'おっきくなったリス！\nまだ小さいリスって？\nそんなことないリス！',
    greetings_en: "I got bigger! Don't you think so?",
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'fish',
    stage: 'kid',
    player_level: 999,
    encyclopedia_order: 211,
    name_jp: 'ぶるぶる科ウオ属',
    name_en: 'fish',
    greetings_jp: 'ちょっとだけ大きくなったウオ？',
    greetings_en: 'I got bigger, right?',
    stomach_sec: 72,
    love_sec: 96,
    dirtiness_sec: 120,
    urine_sec: 144,
    tooth_acidity_sec: 108,
    scared_coefficient: 1.5,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },

  {
    id: 'seaotter',
    stage: 'youth',
    player_level: 1,
    encyclopedia_order: 302,
    name_jp: 'ぶるぶる科ラッコ属',
    name_en: 'seaotter',
    greetings_jp: 'これからもいっぱい\n遊んでほしいッコ！',
    greetings_en: 'Keep playing with me\b!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    next_weights: {
      whale: 500,
      giraffe: 500,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'cat',
    stage: 'youth',
    player_level: 1,
    encyclopedia_order: 303,
    name_jp: 'ぶるぶる科ネコ属',
    name_en: 'cat',
    greetings_jp: 'よろしくだミャー。\nむにゃむにゃ…。',
    greetings_en: "I'm still sleepy...",
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    next_weights: {
      giraffe: 500,
      whale: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'whitedog',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 304,
    name_jp: 'ぶるぶる科シロイヌ属',
    name_en: 'whitedog',
    greetings_jp: 'ひ！\nよろしくネ！',
    greetings_en: 'Wow! Hi!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'pinkdog',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 305,
    name_jp: 'ぶるぶる科モコイヌ属',
    name_en: 'pinkdog',
    greetings_jp: 'もっともーっと、\n仲良くして欲しいモコ。',
    greetings_en: 'Please play with me more and more!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'rabbit',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 306,
    name_jp: 'ぶるぶる科ウサ属',
    name_en: 'rabbit',
    greetings_jp: 'かまって欲しいっピョン？\nちょっとだけならいいピョンよ。',
    greetings_en: 'Do you want to play with me? OK, but only a little!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'browndog',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 307,
    name_jp: 'ぶるぶる科チャイヌ属',
    name_en: 'browndog',
    greetings_jp: 'おもちゃが好きっチャ！\nよろしくっチャ！',
    greetings_en: 'I like toys!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'graydog',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 308,
    name_jp: 'ぶるぶる科パグ属',
    name_en: 'graydog',
    greetings_jp:
      'あれー？どなたでしたっパ？\nあ、{player_name}！\nこれからもよろしくッパ！',
    greetings_en:
      'Hmm? Who were you? Oh, {player_name}! Looking forward to playing with you more!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'pig',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 309,
    name_jp: 'ぶるぶる科ブタ属',
    name_en: 'pig',
    greetings_jp: '{pet_name}のこと、\n食べようとしてるブー？\nぶるぶる…。',
    greetings_en: 'Are you trying to eat me..?',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'penguin',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 310,
    name_jp: 'ぶるぶる科ペン属',
    name_en: 'penguin',
    greetings_jp: '最近寒い日が続くペンね…。\nこたつ出してもらえるペン？',
    greetings_en: "It's getting cold... May I have a kotatsu?",
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'bluedog',
    stage: 'youth',
    player_level: 999,
    encyclopedia_order: 311,
    name_jp: 'ぶるぶる科マゲ属',
    name_en: 'bluedog',
    greetings_jp: 'これからも、\nよろしくお願いするナリ！',
    greetings_en: 'Looking forward to playing with you more!',
    stomach_sec: 144,
    love_sec: 192,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 144,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'whale',
    stage: 'adult',
    player_level: 1,
    encyclopedia_order: 401,
    name_jp: 'ぶるぶる科クジラ属',
    name_en: 'whale',
    greetings_jp: 'もうオトナなのラー。\nこれからもよろしくラー。',
    greetings_en: "Now I'm a real adult.",
    stomach_sec: 144,
    love_sec: 240,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 180,
    scared_coefficient: 1,
    next_weights: {
      ball: 500,
      starball: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'giraffe',
    stage: 'adult',
    player_level: 1,
    encyclopedia_order: 402,
    name_jp: 'ぶるぶる科キリン属',
    name_en: 'giraffe',
    greetings_jp:
      'こんなに大きくなったリン！\nこれから、もーーーーーっと、\n仲良くして欲しいリン！',
    greetings_en: 'I got this big! Pleaes play with me more!',
    stomach_sec: 144,
    love_sec: 240,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 180,
    scared_coefficient: 1,
    next_weights: {
      starball: 500,
      ball: 200,
    },
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'bear',
    stage: 'adult',
    player_level: 999,
    encyclopedia_order: 403,
    name_jp: 'ぶるぶる科クマ属',
    name_en: 'bear',
    greetings_jp:
      'この出会い、\nまさしく一期一会クマ。\n向後万端、よろしくクマ！',
    greetings_en:
      'This encounter is truly once in a lifetime. I look forward to playing with you in the future.',
    stomach_sec: 144,
    love_sec: 240,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 180,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'panda',
    stage: 'adult',
    player_level: 999,
    encyclopedia_order: 404,
    name_jp: 'ぶるぶる科パンダ属',
    name_en: 'panda',
    greetings_jp:
      'オトナになったパン！\nこれからも楽しく遊んで\n欲しいんパン！',
    greetings_en: 'I became an adult! Please play with me more!',
    stomach_sec: 144,
    love_sec: 240,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 180,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
  {
    id: 'dinosaur',
    stage: 'adult',
    player_level: 999,
    encyclopedia_order: 405,
    name_jp: 'ぶるぶる科ザウルス属',
    name_en: 'dinosaur',
    greetings_jp:
      '{pet_name}、もう\nすっかりオトナなノ！\nすごく大きくて強いノ！',
    greetings_en: "I'm already a grown-up now! Very big and strong!",
    stomach_sec: 144,
    love_sec: 240,
    dirtiness_sec: 240,
    urine_sec: 288,
    tooth_acidity_sec: 180,
    scared_coefficient: 1,
    reborn_weights: {
      ball: 500,
      starball: 200,
    },
  },
];
